export default __webpack_public_path__ + "static/media/icon-node-tipo-imagem.fe27c0f5.svg";